import React, { createContext, ReactNode, useContext, useState } from "react";

interface INewClauseContext {
  query: string;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  loadingQuery: boolean;
  setLoadingQuery: React.Dispatch<React.SetStateAction<boolean>>;
  queryReply: string;
  setQueryReply: React.Dispatch<React.SetStateAction<string>>;
  loadingInsertion: boolean;
  setLoadingInsertion: React.Dispatch<React.SetStateAction<boolean>>;
  madeRequest: boolean;
  setMadeRequest: React.Dispatch<React.SetStateAction<boolean>>;
}

const NewClauseContext = createContext<INewClauseContext | null>(null);

export const NewClauseProvider = ({ children }: { children: ReactNode }) => {
  const [query, setQuery] = useState("");
  const [loadingQuery, setLoadingQuery] = useState(false);
  const [queryReply, setQueryReply] = useState("");
  const [loadingInsertion, setLoadingInsertion] = useState(false);
  const [madeRequest, setMadeRequest] = useState(false);

  return (
    <NewClauseContext.Provider
      value={{
        query,
        setQuery,
        loadingQuery,
        setLoadingQuery,
        queryReply,
        setQueryReply,
        loadingInsertion,
        setLoadingInsertion,
        madeRequest,
        setMadeRequest,
      }}
    >
      {children}
    </NewClauseContext.Provider>
  );
};

export const useNewClause = () => {
  const context = useContext(NewClauseContext);
  if (!context) {
    throw new Error("useNewClause must be used within a NewClauseProvider");
  }

  return context;
};
